/* unplugin-vue-components disabled */import { render } from "./chat.vue?vue&type=template&id=6b721850"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/chats/chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b721850"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b721850', __exports__)) {
    api.reload('6b721850', __exports__)
  }
  
  module.hot.accept("./chat.vue?vue&type=template&id=6b721850", () => {
    api.rerender('6b721850', render)
  })

}


export default __exports__